import { CaretLeftIcon, CaretRightIcon } from '@lingoda/ui/icons/lingodaIcons';
import { Button, Stack, Tooltip, colorsPalette, styled, useResolution } from '@lingoda/ui';
import { trans } from '@lingoda/i18n';
import { type BookingFilter } from '@lingoda/booking';
import { useBookingFilterDateSelector } from '@lingoda/booking-filter';

interface DateNavigationProps {
    onFilterChange: (newFilter: Partial<BookingFilter>) => void;
    bookingFilter: BookingFilter;
}

export const DayNavigation = ({ bookingFilter, onFilterChange }: DateNavigationProps) => {
    const oneDate = bookingFilter.dates[0];

    const { selectPrevDate, selectNextDate, isPrevDateDisabled, isNextDateDisabled } =
        useBookingFilterDateSelector(oneDate, bookingFilter.timeSlots, onFilterChange);
    const isMobile = useResolution('phone');

    return (
        <Stack
            spacing={1}
            direction="row"
            mt={(navigationSizeUnits - labelHeightUnits) * -0.75}
            mb={(navigationSizeUnits - labelHeightUnits) * -0.25}
        >
            <Tooltip
                title={trans('previous-date', {}, 'student-common')}
                placement="top"
                arrow
                disableHoverListener={isMobile}
            >
                <DayNavigationButton
                    color="primary"
                    variant="outlined"
                    onClick={selectPrevDate}
                    disabled={isPrevDateDisabled}
                    aria-label={trans('previous-date', {}, 'student-common')}
                >
                    <CaretLeftIcon size={12} />
                </DayNavigationButton>
            </Tooltip>
            <Tooltip
                title={trans('next-date', {}, 'student-common')}
                placement="top"
                arrow
                disableHoverListener={isMobile}
            >
                <DayNavigationButton
                    color="primary"
                    variant="outlined"
                    onClick={selectNextDate}
                    disabled={isNextDateDisabled}
                    aria-label={trans('next-date', {}, 'student-common')}
                >
                    <CaretRightIcon size={12} />
                </DayNavigationButton>
            </Tooltip>
        </Stack>
    );
};

const labelHeightUnits = 3;
const navigationSizeUnits = 5;

const DayNavigationButton = styled(Button)(({ theme }) => ({
    width: theme.spacing(navigationSizeUnits),
    minWidth: theme.spacing(navigationSizeUnits),
    height: theme.spacing(navigationSizeUnits),
    padding: 0,
    borderColor: theme.palette.divider,
    color: theme.palette.primary.main,
    '&.Mui-disabled': {
        color: colorsPalette.blackAlpha[30],
    },
}));
